import { Progress } from "antd";
import { BatchProcessingStatus, type CaseFileBatch } from "@/briefpoint-client";

interface BatchProcessingLoaderProps {
  batch: CaseFileBatch;
  onRetry?: () => void;
}

const BatchProcessingLoader = (props: BatchProcessingLoaderProps) => {
  const processedPageCount =
    props.batch.files
      ?.filter((file) => file.processingSuccess === true)
      .reduce((total, file) => total + (file.pageCount || 0), 0) || 0;

  const totalPageCount =
    props.batch.files?.reduce(
      (total, file) => total + (file.pageCount || 0),
      0,
    ) || 0;

  const progressPercent = Math.floor(
    (processedPageCount / totalPageCount) * 100,
  );

  const batchStatus = props.batch.status || BatchProcessingStatus.NotStarted;

  return (
    <div className="pt-2">
      <div className="mx-auto text-center" style={{ maxWidth: "700px" }}>
        <div data-testid="processing-documents" className="fw-bold fs-3">
          {batchStatus === BatchProcessingStatus.Running
            ? "Processing your documents..."
            : "Processing queued"}
        </div>
        <p>
          It's safe to leave this page. We'll send you an email when processing
          is complete.
        </p>
        {batchStatus === BatchProcessingStatus.Running && (
          <>
            <Progress
              percent={progressPercent}
              strokeColor="var(--primary-2)"
            />
            <div className="d-flex justify-content-between">
              <p>
                {processedPageCount} of {totalPageCount} pages completed
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BatchProcessingLoader;
